import { Svg } from 'components/svg'
import { FC, SVGAttributes } from 'react'

export const IconMagnify: FC<SVGAttributes<SVGSVGElement>> = props => (
  <Svg {...props} viewBox="0 0 19 16">
    <path
      d="M14.4317 15.8721L8.66472 10.1061C6.50854 11.5285 3.62574 11.0885 1.99205 9.08762C0.358363 7.08676 0.503816 4.1742 2.32872 2.34607C4.15653 0.520463 7.06943 0.37438 9.07072 2.00795C11.072 3.64153 11.5123 6.52467 10.0897 8.68107L15.8547 14.4481L14.4317 15.8721ZM5.88872 2.88606C4.44797 2.88515 3.2072 3.90209 2.92521 5.31497C2.64321 6.72786 3.39853 8.14319 4.72925 8.69542C6.05996 9.24765 7.59546 8.78298 8.39671 7.58558C9.19795 6.38818 9.04179 4.79153 8.02372 3.77207C7.45897 3.20341 6.69017 2.88437 5.88872 2.88606ZM16.8547 6.87207H14.8547V4.87207H12.8547V2.87207H14.8547V0.87207H16.8547V2.87207H18.8547V4.87207H16.8547V6.87207Z"
      fill="white"
    />
  </Svg>
)
